import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/ic-arrow-back.svg'
import _imports_1 from '@/assets/images/ic-upload.svg'


const _hoisted_1 = {
  class: "page__header",
  style: {"margin-bottom":"0"}
}
const _hoisted_2 = { class: "page__header-title" }
const _hoisted_3 = { class: "page__stats page__stats--split" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "Объекты", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Налогоплательщики", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "НП с ККМ", -1)
const _hoisted_7 = { class: "map-stat__item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "НП без ККМ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, " Статусы налогоплательщиков ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "page__stats-point page__stats-point--6" }),
  /*#__PURE__*/_createElementVNode("span", null, "Обработан")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "page__stats-point page__stats-point--3" }),
  /*#__PURE__*/_createElementVNode("span", null, "Не обработан")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, " Статусы объектов ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "page__stats-point page__stats-point--6" }),
  /*#__PURE__*/_createElementVNode("span", null, "Обработан")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "page__stats-point page__stats-point--3" }),
  /*#__PURE__*/_createElementVNode("span", null, "Не обработан")
], -1)
const _hoisted_15 = { class: "page__tno-tabs" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_17 = { class: "registry-upload__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlatTabs = _resolveComponent("FlatTabs")!
  const _component_PageControls = _resolveComponent("PageControls")!
  const _component_UploadNewUsers = _resolveComponent("UploadNewUsers")!
  const _component_UploadNewItems = _resolveComponent("UploadNewItems")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "page__header-back",
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({name: 'registry-ugns-index'})))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.info?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", null, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("td", null, _toDisplayString(_ctx.stats.values?.taxObject || 0), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("td", null, _toDisplayString(_ctx.stats.values?.taxPayer || 0), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("td", null, _toDisplayString(_ctx.stats.values?.kkm || 0), 1)
          ]),
          _createElementVNode("tr", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("td", null, _toDisplayString(_ctx.stats.values?.emptyKkm || 0), 1)
          ])
        ])
      ]),
      _createElementVNode("table", null, [
        _hoisted_9,
        _createElementVNode("tr", null, [
          _hoisted_10,
          _createElementVNode("td", null, _toDisplayString(_ctx.stats.nalogPayer?.processed), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_11,
          _createElementVNode("td", null, _toDisplayString(_ctx.stats.nalogPayer?.notprocessed), 1)
        ])
      ]),
      _createElementVNode("table", null, [
        _hoisted_12,
        _createElementVNode("tr", null, [
          _hoisted_13,
          _createElementVNode("td", null, _toDisplayString(_ctx.stats.statusStat?.processed), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_14,
          _createElementVNode("td", null, _toDisplayString(_ctx.stats.statusStat?.notprocessed), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_FlatTabs, {
        tabs: _ctx.tabs,
        currentTabIndex: _ctx.currentTabIndex,
        onTabClick: _ctx.tabClick,
        style: {"margin-bottom":"2rem"}
      }, null, 8, ["tabs", "currentTabIndex", "onTabClick"]),
      (_ctx.$store.state.auth.isTno)
        ? (_openBlock(), _createBlock(_component_PageControls, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("label", {
                class: "registry-upload",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleUploadClick && _ctx.handleUploadClick(...args)))
              }, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, "Загрузка " + _toDisplayString(_ctx.$route.query.tab === 'ObjectsTab' ? 'объектов' : 'пользователей'), 1)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTab.id), _normalizeProps(_guardReactiveProps({ isAdmin: _ctx.isAdmin, ugnsId: _ctx.ugnsId })), null, 16)),
    (_ctx.showUploadNewUsers)
      ? (_openBlock(), _createBlock(_component_UploadNewUsers, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUploadNewUsers = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showUploadNewItems)
      ? (_openBlock(), _createBlock(_component_UploadNewItems, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showUploadNewItems = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}